<template>
  <div class="h-100">
    <div class="vue-datatables">
      <div class="row mb-3" v-if="types">
        <div class="col" v-for="option in types" v-if="option.count">
          <type-filter :is-selected="selectedCustomFilter == option.key" :option="option"
            @selected="doCustomFilter('leadType' ,option.key)"
          />
        </div>
      </div>
      <div class="bg-white p-2 rounded shadow pt-4 position-relative pt-3">
        <div class="position-absolute pos-t-1 pos-l-2">
          <div class="d-flex justify-content-between">

            <!-- Leads Status Filter-->
            <select class="ml-1" ref="leadsStatuses" name="leadsStatuses"
                    @change="doCustomFilter('statusId',$event.target.value)">
              <option value="">{{$t('orders.statuses')}}</option>
              <option value="1">חדש</option>
              <option v-for="option in statuses" v-if="option.statusGroup == tconfig.statusGroup"
                      :value="option.key">
                {{option.value}}
              </option>
            </select>


            <!-- Print Button -->
            <button @click="print()"
                    class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white">
              <span class="icon-print text-p xy-align"></span>
            </button>

            <input type="file" ref="file" style="display: none" @change="uploadCsv($event)">
            <button v-if="tconfig.enableCsvUpload" @click="$refs.file.click()"
                    class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white">
              <span class="icon-upload text-p xy-align"></span>
            </button>

            <!-- Download excel-->
            <div v-if="isAdmin || isManagement" class="btn-group dropleft" role="group">
              <button id="downloadBtnGroup" type="button"
                      class="border border-gray-2 rounded-circle position-relative p-2 mr-1 bg-white"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                <span class="icon-download text-p xy-align"></span>
              </button>
              <div class="dropdown-menu" aria-labelledby="downloadBtnGroup">
                <a class="dropdown-item" href="#" @click="downloadExcel($route.name+'.csv')">
                  Download Excel
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="(isAdmin || isManagement) &&  previewOrderList.length > 0"  class="btn-group dropleft py-2" role="group">
        <!--      <button class="border border-gray-2 position-relative bg-success" data-toggle="modal" data-target="#whatsappMessagesModel">-->
<!--        <button class="btn btn-sm btn-primary position-relative mx-1" @click="() => openCampaignStatusesModal(true)">
          <span class="text-white">עדכון סטטוס קבוצתיות</span>
        </button>-->

<!--        <button class="btn btn-sm btn-success position-relative" @click="() => openCampaignModal('whatsappCampaign')">
          <span class="text-white">הודעות וואטסאפ קבוצתיות</span>
        </button>-->

<!--        <button class="btn btn-sm btn-primary position-relative mx-1" @click="() => openCampaignModal('smsCampaign')">
          <span class="text-white">הודעות SMS קבוצתיות</span>
        </button>-->

<!--        <button class="btn btn-sm btn-primary position-relative" @click="() => openCampaignModal('mailCampaign')">
          <span class="text-white">הודעות Mail קבוצתיות</span>
        </button>-->
      </div>

      <loader v-if="inProgress"/>
      <v-server-table ref="myTable" @loading="onLoading(true)" @loaded="onLoading(false)" :columns="columns" :selectedColumns="['id','fullName']"
                      :options="options">

        <!-- SLOTS FIELDS EDIT -->
        <template v-for="(item, k) in columns" :slot="'h__' + item">
          <span>{{ $t('tables.headers.' + item) }}</span>
          <input v-if="k === 0 " type="checkbox"  name="selectAll" v-model="rolesSelected" class="align-self-center" @click='selectAll($event)' />
        </template>

        <!-- TABLE CONTROLLERS -->
        <div slot="beforeLimit">
          <div class="d-flex justify-content-between ml-2">


            <div v-if="!tconfig.hideDateFilter" class="input-group">
              <input class="form-control"
                     type="text"
                     :placeholder="$t('message.dateFilter')"
                     name="daterange"
                     @focus="openDateRange">
              <div class="input-group-append">
                <button class="btn btn-danger" type="button" v-if="dateFilter"
                        @click="clearDateFilter()">
                  {{ $t('message.clean') }}
                </button>
                <div v-else
                     class="input-group-text px-1 d-flex justify-content-center align-items-center">
                  <span class="icon-calendar"></span>

                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-for="(item) in tconfig.schema" v-slot:[item.name]="props">
          <div class="td-wrapper" :ref="props.row.id+'_'+item.name">
            <template v-if="item.options">
              <div v-html="translateById(props.row[item.name], item.options)"></div>
            </template>

            <span v-else>
              <span v-if="isPhone(item.name) && props.row[item.name]"
                :style="{'color' : $route.name === 'statuses' && item.name === 'color' ? props.row['color'] + '!important' : ''}">{{ props.row[item.name] }}<span class="cursor-pointer" @click="handleUserWhatsapp(props.row['phone'], props.row['fullName'])"><img src="assets/images/whatsapp.png"> </span><a :href="`/orders?dbSearch=${ props.row[item.name] }`" target="_blank" class="btn btn-link px-1"><img src="assets/images/search.png"></a></span>
              <span v-else
                :style="{'color' : $route.name === 'statuses' && item.name === 'color' ? props.row['color'] + '!important' : ''}">{{ props.row[item.name] }}</span>
            </span>
            <form-control v-if="item.editable"
                          :type="item.type"
                          :name="item.name"
                          :id="`${item.name}_${props.row.id}`"
                          :data-lead_id="`${props.row.id}`"
                          classes="mb-0"
                          :class="item.name == 'statusId11' ? 'status-update mb-0' : 'd-none mb-0'"
                          v-validate="item.validation"
                          v-model="props.row[item.name]"
                          :options="getFieldOptions(item.options)"
                          :error="errors.first(item.name)"
                          :val="props.row[item.name]"
            />
          </div>
        </template>
        <!-- ROW ACTIONS -->
        <template v-slot:actions="props">
          <div class="d-flex justify-content-around h-100">
            <RowActions
              :route="$route"
              :id="'preview-order-list'+'_'+props.row.id"
              :value="props.row.id.toString()"
              @catchPreviewList="catchPreviewList"
              :phoneNumber="props.row['phone']"
            />
            <router-link :to="`view?table=leads&id=${props.row.id}`" target="_blank">
              <span class="icon icon-doublearrowleft"></span>
            </router-link>
            <!--<button class="btn btn-sm btn-color-1 mx-1" @click="openPopup">
                  <span class="icon icon-doublearrowright"></span>
            </button> -->
          </div>
        </template>

      </v-server-table>

      <CampaignMessages
        ref="campaignMessagesModel"
        id="campaignMessagesModel"
        :messages=campaignMessages
        :campaignKind=campaignKind
        :previewOrderList=previewOrderList
        model="Lead"
      />

      <CampaignStatuses v-if="openStatusCampaign"
        ref="campaignStatusesModel"
        id="campaignStatusesModel"
        :tconfig=tconfig
        :statuses=leadType
        :previewOrderList=previewOrderList
        component="leads"
        @addNoteAfterStatusUpdate="addNoteAfterStatusUpdate"
        model="Lead"
      />
    </div>
  </div>
</template>

<script>
import axios from '../axios'
import config from '../table-config';
import DataTable from "@/mixins/DataTable";
import FormControl from "@/components/formcontrol";
import Auth from "@/mixins/Auth";
import Excel from "@/mixins/Excel";
import TypeFilter from "@/components/TypeFilter";
import {isEqual, pickBy} from "lodash";
import loader from '@/components/loader'
import RowActions from "@/components/rowActions.vue";
import CampaignMessages from "@/views/Modal/campaignMessagesModel.vue";
import CampaignStatuses from "@/views/Modal/campaignStatusesModel.vue";
import {checkWhatsappUser, splitName} from "@/utils/utilsFunctions";


export default {
  name: "LeadsView",
  components: {CampaignMessages, CampaignStatuses, RowActions, TypeFilter, FormControl, loader},
  mixins: [DataTable, Auth, Excel],
  data() {
    return {
      types: [],
      rows: [],
      selectedCustomFilter: null,
      tconfig: {},
      leadType: {},
      inProgress: false,
      openStatusCampaign: false,
      config: {
        schema: config.leads.schema
      },
      statuses: [],
      previewOrderList: [],
      campaignMessages: [],
      rolesSelected: '',
      campaignKind: '',
      options: {
        perPageValues: [
          25,
          50,
          100,
        ],
        perPage: 50,
        initFilters: {
          GENERIC: this.$route.query.query ?this.$route.query.query:"",
          ...pickBy(this.$route.query)
        },
        filterable: true,
        dateColumns: [],
        columnsDropdown: this.$store.getters.isAdmin || this.$store.getters.isManagement || '',

        async requestFunction(params) {
          const query = pickBy(Object.assign({}, params));

          if (Object.keys(query).length && !isEqual(query, this.$route.query)) {
            try {
              await this.$router.push({query});
            } catch (e) {
            }
          }
          
          // Add modeSource to params
          params.modeSource = this.$store.getters.currentModeSource || 'hova';
      
          const response = await axios.post(`/v2/leads`, params);

          return {data: response.data.data, count: response.data.total}
          //return await axios.post(`/v2/leads`, params);
        },
        // responseAdapter(response) {
        //
        //   return {data: response.data.data, count: response.data.total}
        // },
        sortable: [
          "id",
          "subject",
          "fullName",
          "phone",
          "tz",
          "email",
          "insurance_select_period",
          "license_number",
          "content",
          "leadType",
          "source",
          "followUp",
          "statusId",
          "extra",
          "created_at"
        ],
        sortIcon: {
          "base": "fontawesome",
          "up": "fa fa-chevron-up",
          "down": "fa fa-chevron-down",
          "is": "fa fa-sort"
        },
        customFilters: [
          "leadType", "statusId", "date"
        ],
        texts: {
          "count": "מציג {from} עד {to} מתוך {count} רשומות|{count} רשומות|רשומה 1",
          "filter": "",
          "filterPlaceholder": "ביטוי לחיפוש",
          "limit": "רשומות",
          "limitPlaceholder": "רשומות",
          "page": "עמוד",
          "noResults": "לא נמצאו רשומות",
          "filterBy": "סנן לפי {column}",
          "loading": "טוען...",
          "defaultOption": "בחר {column}",
          "columns": "עמודות"
        },
      }

    }
  },
  computed: {
    tcfilters() {
      return this.tconfig.cfilters
    },
    columns() {
      return this.config.schema.map(r => r.name);
     /* return [
          "subject",
          "fullName",
          "phone",
          "statusId",
          "extra"
        ]; */

    }
  },
  methods: {
    onLoading(inProgress) {
      this.inProgress = inProgress
    },
    isPhone(name){
      if(name == 'phone'){
        return true;
      } else {
        return false;
      }
    },
    selectAll (e) {
      let that = this;
      if(this.rows.length === 0) {
        this.options.requestFunction().then((res)=> {
          this.rows = JSON.parse(JSON.stringify(res.data))
        })
      }
      let tmp = [];
      for (let row in this.rows) {
        let id = this.rows[row]['id'];
        let mobilePhone = this.rows[row]['phone'];
        let name = 'preview-order-list_'+id
        $('#'+name).prop('checked', event.target.checked);


        if(event.target.checked) {
          let checked = {
            "id": id,
            "mobilePhone": mobilePhone
          };
          tmp.push(checked);
        }
      }


      this.previewOrderList = event.target.checked ? tmp : [];
    },
    catchPreviewList(mobilePhoneNumber) {
      let tmp = [];
      $("input[name='preview-order-list']").each(function () {
        if ($(this).is(':checked')) {
          let checked = {
            "id": ($(this).val()),
            "mobilePhone": mobilePhoneNumber
          };
          tmp.push(checked);
        }
      });
      this.previewOrderList = tmp;
    },
    openCampaignModal(prefix) {
      if(!prefix) {
        console.log('prefix not found')
        return
      }
      this.dataTableReady = true;
      this.campaignKind = prefix;
      let that = this;
      axios.post(`${prefix}/all`)
        .then((res) => {
          that.dataTableReady = false;
          that.campaignMessages = res.data.data.rows;

          setTimeout(() => {
            let element = that.$refs.campaignMessagesModel.$el
            $(element).modal('show')
          }, 1000)
        }).catch((err) => {
        this.dataTableReady = false;
        this.$emit('alert', 'danger', err.response.data.status)
      })

      //let element = this.$refs.modal.$el
    },

    openCampaignStatusesModal(action) {
      let that = this;
      if(!action) {
        return;
      }
      this.openStatusCampaign = true;
      setTimeout(() => {
        let element = that.$refs.campaignStatusesModel.$el
        $(element).modal('show')
      }, 1000)

    },
    addNoteAfterStatusUpdate(res) {

      if(!res) {
        console.log('Error - can not update multi note');
      }

      for (let k in res) {
        let rowId = res[k]['row']['id'];
        //translate old value
        let msgContent = '';
        for (let i in this.statuses) {
          if (this.statuses[i].key == res[k]['oldStatusId']) {
            msgContent += this.statuses[i].value
          }
        }
        //translate new value
        for (let i in this.statuses) {
          if (this.statuses[i].key == res[k]['row']['statusId']) {
            msgContent += ' > ' + this.statuses[i].value
          }
        }

        const data = {
          subject: 'שינוי סטטוס',
          description: msgContent
        };

        //this.addNewNote(note, false, false, 'orderStatus');
        axios.post(`leads/addNote/${rowId}`, data)
      }

    },
    handleUserWhatsapp(phone, fullName) {

      if(!phone || !fullName  ) {
        return;
      }
      let parts = splitName(fullName);

      const firstName = parts[0];
      const lastName = parts[1]; // כל השאר


      checkWhatsappUser(phone, firstName, lastName)

    },

  },


  async created() {
    let tconfig = config.leads

    if (tconfig) {
      this.tconfig = tconfig
    } else {
      this.tconfig = {}
    }
    try {

      let response = await axios.post("v2/leads/options", {
        modeSource: this.$store.getters.currentModeSource || 'hova'
      });
      this.types = response.data.leadType
      this.leadType = response.data.leadType
      this.statuses = response.data.statuses
      this.tconfig.options = response.data;
    } catch (e) {

    }
  }
}
</script>

<style scoped>

</style>
